import React, { useState, useRef, useEffect } from 'react';
import { Form, Alert } from 'react-bootstrap';
import axios from 'axios';
import Ctabg from '../../images/contact-bg.jpg';
import NewsVector from '../../images/news-vector.png';

const TOPICS = [
    { label: "Building & Construction", name: "tfa_19" },
    { label: "Business and Contracts", name: "tfa_20" },
    { label: "Consumer", name: "tfa_21" },
    { label: "Corporate & In-House Counsel", name: "tfa_22" },
    { label: "Costs", name: "tfa_23" },
    { label: "Criminal", name: "tfa_24" },
    { label: "Employment & Workplace Relations", name: "tfa_25" },
    { label: "Ethics", name: "tfa_26" },
    { label: "Family", name: "tfa_27" },
    { label: "Finance, Tax, Superannuation", name: "tfa_28" },
    { label: "Government, Privacy & FOI", name: "tfa_29" },
    { label: "Insolvency & Restructuring", name: "tfa_30" },
    { label: "Intellectual Property", name: "tfa_31" },
    { label: "Litigation & Advocacy", name: "tfa_32" },
    { label: "Migration", name: "tfa_33" },
    { label: "Personal Injury & Medico-Legal", name: "tfa_34" },
    { label: "Professional Skills & Practice Management", name: "tfa_35" },
    { label: "Property, Leases & Planning", name: "tfa_36" },
    { label: "Sports Law", name: "tfa_37" },
    { label: "Wills, Trusts & Succession Planning", name: "tfa_38" },
];

// Email regex — same pattern used throughout the app
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// serialize() — unchanged, required for TFA form field serialization
const serialize = (form) => {
    var field, s = [];
    if (typeof form === 'object' && form.nodeName === "FORM") {
        var len = form.elements.length;
        for (var i = 0; i < len; i++) {
            field = form.elements[i];
            if (field.name && !field.disabled && field.type !== 'file' && field.type !== 'reset' && field.type !== 'submit' && field.type !== 'button') {
                if (field.type === 'select-multiple') {
                    for (var j = form.elements[i].options.length - 1; j >= 0; j--) {
                        if (field.options[j].selected)
                            s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[j].value);
                    }
                } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                    s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value);
                }
            }
        }
    }
    return s.join('&').replace(/%20/g, '+');
};

export const CTASection = (props) => {

    const [formKey, setFormKey] = useState(0); // increment to reset form
    const [signupOpen, setSignupOpen] = useState(false);
    const [topicsOpen, setTopicsOpen] = useState(false);
    const [selectedTopics, setSelectedTopics] = useState([]);
    const [SuccessMessage, setSuccessMessage] = useState(undefined);
    const [ErrorMessage, setErrorMessage] = useState(undefined);
    const [SomethingUpadating, setSomethingUpadating] = useState(false);
    const topicsRef = useRef(null);

    const [firstName_ER, setFirstName_ER] = useState(false);
    const [lastName_ER, setLastName_ER] = useState(false);
    const [email_ER, setEmail_ER] = useState(false);
    const [organisation_ER, setOrganisation_ER] = useState(false);
    const [topics_ER, setTopics_ER] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [organisation, setOrganisation] = useState('');


    /**
     * Auto-dismiss the mailing-list success message after a standard 5s, so the
     * "Thank you for signing up" confirmation doesn't linger on the page.
     */
    useEffect(() => {
        if (SuccessMessage !== undefined) {
            const timer = setTimeout(() => setSuccessMessage(undefined), 5000);
            return () => clearTimeout(timer);
        }
    }, [SuccessMessage]);

    // Close topics dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (topicsRef.current && !topicsRef.current.contains(e.target)) {
                setTopicsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleTopic = (topic) => {
        setSelectedTopics(prev =>
            prev.includes(topic.name)
                ? prev.filter(n => n !== topic.name)
                : [...prev, topic.name]
        );
        if (topics_ER) setTopics_ER(false);
    };

    const removeTopic = (e, name) => {
        e.stopPropagation();
        setSelectedTopics(prev => prev.filter(n => n !== name));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setSuccessMessage(undefined);
        setErrorMessage(undefined);

        // ── Validate directly from React state — no DOM access needed ──────────
        // Controlled inputs keep values in state — trim here for validation only
        const form = document.getElementById('49516833');
        const firstNameVal = firstName.trim();
        const lastNameVal = lastName.trim();
        const emailVal = email.trim();
        const organisationVal = organisation.trim();

        // Validate synchronously into local vars (React batching — not state)
        const err_first = !firstNameVal;
        const err_last = !lastNameVal;
        const err_email = !emailVal || !EMAIL_RE.test(emailVal);
        const err_org = !organisationVal;
        const err_topics = selectedTopics.length === 0;

        setFirstName_ER(err_first);
        setLastName_ER(err_last);
        setEmail_ER(err_email);
        setOrganisation_ER(err_org);
        setTopics_ER(err_topics);

        if (err_first || err_last || err_email || err_org || err_topics) return;

        if (!form) {
            setErrorMessage("Something went wrong. Please refresh and try again.");
            return;
        }

        setSomethingUpadating(true);
        const finalDate2 = serialize(form);

        axios.post(props.EngineURL + 'signup/index.php', finalDate2, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
            .then(function (response) {
                // Removed setTimeout — no benefit, can cause stale state on slow connections
                if (response?.data?.code === 200) {
                    setSuccessMessage(true); // flag only — don't render API HTML into DOM (XSS risk)
                    if (response.data.new_practice_area) {
                        localStorage.setItem("new_practice_area", response.data.new_practice_area);
                    }
                    // Clear form via React state
                    setFirstName('');
                    setLastName('');
                    setEmail('');
                    setOrganisation('');
                    setSelectedTopics([]);
                    setSignupOpen(false);
                    setTopicsOpen(false);
                    setTopics_ER(false);
                    // Increment formKey to force full form remount —
                    // this resets hidden/uncontrolled fields in production builds
                    setFormKey(k => k + 1);
                } else {
                    if (response.data.message) {
                        setErrorMessage(response.data.message);
                    }else{
                        setErrorMessage("Something went wrong. Please try again.");
                    }
                    // Show generic message — don't show raw API message to user
                    
                }
                setSomethingUpadating(false);
            })
            .catch(function (error) {
                // Never console.log(error) in production — exposes stack traces
                setSomethingUpadating(false);
                if (error.response) {
                    if (error.response.status === 429) {
                        setErrorMessage("Too many requests. Please wait a moment and try again.");
                    } else if (error.response.status >= 500) {
                        setErrorMessage("A server error occurred. Please try again later.");
                    } else {
                        setErrorMessage("Something went wrong. Please try again.");
                    }
                } else if (error.request) {
                    // FIXED: this branch means "request sent, no response received"
                    // (network drop, CORS block, timeout) — NOT necessarily rate limiting.
                    // The real 429 case is already handled above via error.response.status.
                    setErrorMessage("Could not reach the server. Please check your connection and try again.");
                } else {
                    setErrorMessage("Something went wrong. Please try again.");
                }
            });

        // axios.get(props.EngineURL + 'signup/index.php?' + finalDate2)
        //     .then(function (response) {
        //         // Removed setTimeout — no benefit, can cause stale state on slow connections
        //         if (response?.data?.code === 200) {
        //             setSuccessMessage(true); // flag only — don't render API HTML into DOM (XSS risk)
        //             if (response.data.new_practice_area) {
        //                 localStorage.setItem("new_practice_area", response.data.new_practice_area);
        //             }
        //             // Clear form via React state
        //             setFirstName('');
        //             setLastName('');
        //             setEmail('');
        //             setOrganisation('');
        //             setSelectedTopics([]);
        //             setSignupOpen(false);
        //             setTopicsOpen(false);
        //             // Increment formKey to force full form remount —
        //             // this resets hidden/uncontrolled fields in production builds
        //             setFormKey(k => k + 1);
        //         } else {
        //             // Show generic message — don't show raw API message to user
        //             setErrorMessage("Something went wrong. Please try again.");
        //         }
        //         setSomethingUpadating(false);
        //     })
        //     .catch(function (error) {
        //         // Never console.log(error) in production — exposes stack traces
        //         setSomethingUpadating(false);
        //         if (error.response) {
        //             if (error.response.status === 429) {
        //                 setErrorMessage("Too many requests. Please wait a moment and try again.");
        //             } else if (error.response.status >= 500) {
        //                 setErrorMessage("A server error occurred. Please try again later.");
        //             } else {
        //                 setErrorMessage("Something went wrong. Please try again.");
        //             }
        //         } else if (error.request) {
        //             setErrorMessage("Too many requests. Please wait a moment and try again.");
        //         } else {
        //             setErrorMessage("Something went wrong. Please try again.");
        //         }
        //     });
    };

    return (
        <div className='cta_wrapper' style={{ backgroundImage: "url(" + Ctabg + ")" }}>
            <div className='cta_inner'>

                    <div className='cta_newsletter_label'>
                        <img src={NewsVector} alt="" className='cta_newsletter_icon' />
                        <span>NEWSLETTER</span>
                    </div>

                    <div className='cta_heading'>
                        <h2 className='cta_title'>Stay informed.</h2>
                        <p className='cta_subtitle'>Get insights from industry practitioners straight into your inbox.</p>
                    </div>

                    <hr className='cta_divider' />

                    <Form key={formKey} className='cta_form' method="post" onSubmit={handleSubmit} id="49516833" noValidate>

                        <div className='cta_field_group'>
                            <div className='cta_field'>
                                <label className='cta_label'>FIRST NAME <span>*</span></label>
                                <Form.Control
                                    name="tfa_2"
                                    type="text"
                                    placeholder="First name"
                                    value={firstName}
                                    className={firstName_ER ? "form-error" : ""}
                                    disabled={SomethingUpadating}
                                    onChange={(e) => { setFirstName(e.target.value); if (firstName_ER) setFirstName_ER(false); }}
                                    required
                                />
                                {firstName_ER && <span className="field-error-msg">First name is required</span>}
                            </div>

                            <div className='cta_field'>
                                <label className='cta_label'>LAST NAME <span>*</span></label>
                                <Form.Control
                                    name="tfa_3"
                                    type="text"
                                    placeholder="Last name"
                                    value={lastName}
                                    className={lastName_ER ? "form-error" : ""}
                                    disabled={SomethingUpadating}
                                    onChange={(e) => { setLastName(e.target.value); if (lastName_ER) setLastName_ER(false); }}
                                    required
                                />
                                {lastName_ER && <span className="field-error-msg">Last name is required</span>}
                            </div>

                            <div className='cta_field'>
                                <label className='cta_label'>EMAIL <span>*</span></label>
                                <Form.Control
                                    name="tfa_1"
                                    type="email"
                                    placeholder="Email address"
                                    value={email}
                                    className={email_ER ? "form-error" : ""}
                                    disabled={SomethingUpadating}
                                    onChange={(e) => { setEmail(e.target.value); if (email_ER) setEmail_ER(false); }}
                                    required
                                />
                                {email_ER && <span className="field-error-msg">Please enter a valid email address</span>}
                            </div>

                            <div className='cta_field'>
                                <label className='cta_label'>ORGANISATION <span>*</span></label>
                                <Form.Control
                                    name="tfa_17"
                                    type="text"
                                    placeholder="Organisation"
                                    value={organisation}
                                    className={organisation_ER ? "form-error" : ""}
                                    disabled={SomethingUpadating}
                                    onChange={(e) => { setOrganisation(e.target.value); if (organisation_ER) setOrganisation_ER(false); }}
                                    required
                                />
                                {organisation_ER && <span className="field-error-msg">Organisation is required</span>}
                            </div>
                        </div>

                        {/* Sign up options — title kept, collapse toggle removed (always open) */}
                        <div className='cta_signup_accordion'>
                            <div className='cta_signup_trigger cta_signup_heading'>
                                <span>
                                    Sign up options <span>*</span>
                                    {selectedTopics.length > 0 && ` (${selectedTopics.length})`}
                                </span>
                            </div>
                            <div className='cta_signup_panel'>
                                    <div className={`cta_topics_field${topics_ER ? ' form-error' : ''}`} ref={topicsRef}>
                                        {/* All practice areas shown as an always-visible checkbox list (no collapse toggle) */}
                                        <div className='cta_topics_dropdown cta_topics_static'>
                                            {TOPICS.map(topic => (
                                                <div
                                                    key={topic.name}
                                                    className={`cta_topics_option${selectedTopics.includes(topic.name) ? ' selected' : ''}`}
                                                    onClick={() => toggleTopic(topic)}
                                                >
                                                    <span className='cta_topics_checkbox'>
                                                        {selectedTopics.includes(topic.name) && (
                                                            <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M1 4L3.5 6.5L9 1" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                        )}
                                                    </span>
                                                    {topic.label}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    {topics_ER && <span className="field-error-msg">Please select at least one topic</span>}

                                    {/* Hidden checkboxes for form serialization */}
                                    <div style={{ display: 'none' }}>
                                        {TOPICS.map(topic => (
                                            <input
                                                key={topic.name}
                                                type="checkbox"
                                                name={topic.name}
                                                value={topic.name}
                                                checked={selectedTopics.includes(topic.name)}
                                                onChange={() => { }}
                                            />
                                        ))}
                                    </div>
                                </div>
                        </div>

                        {/* Hidden TFA fields */}
                        <input type="hidden" value="4951683" name="tfa_dbFormId" id="tfa_dbFormId" />
                        <input type="hidden" value="" name="tfa_dbResponseId" id="tfa_dbResponseId" />
                        <input type="hidden" value="9ddbb774993d2dd282ddaa3326b474d9" name="tfa_dbControl" id="tfa_dbControl" />
                        <input type="hidden" value="" name="tfa_dbWorkflowSessionUuid" id="tfa_dbWorkflowSessionUuid" />
                        <input type="hidden" value="2" name="tfa_dbVersionId" id="tfa_dbVersionId" />
                        <input type="hidden" value="" name="tfa_switchedoff" id="tfa_switchedoff" />

                        {/* Submit button — disabled during request */}
                        <button
                            type="submit"
                            className='cta_submit_btn btn justify-content-center'
                            disabled={SomethingUpadating}
                        >
                            {SomethingUpadating ? 'Please wait…' : 'Submit'}
                            {!SomethingUpadating && (
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 8H13M13 8L9 4M13 8L9 12" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            )}
                        </button>

                        {ErrorMessage !== undefined &&
                            <Alert variant="danger" className='mt-3'>{ErrorMessage}</Alert>
                        }
                        {/* SuccessMessage rendered as plain text — never dangerouslySetInnerHTML */}
                        {SuccessMessage !== undefined &&
                            <Alert variant="primary" className='mt-3'>
                                Thank you for signing up to our mailing list.
                            </Alert>
                        }

                    </Form>
                </div>
            </div>
        );
};

export default CTASection;